import React, { useState } from 'react';
import { createCliente, getCorreoRecepcion } from '../services/api';
import { DEPARTAMENTOS, MUNICIPIOS } from '../data/dianUbicacion';

// Modal de creación de cliente REUTILIZABLE — mismos campos que la página
// Clientes (datos DIAN completos), para que crear un cliente desde cotización,
// remisión o factura capture toda la info requerida por facturación electrónica.
const TIPOS_DOC = [['31', 'NIT'], ['13', 'Cédula de ciudadanía'], ['22', 'Cédula de extranjería'], ['41', 'Pasaporte'], ['12', 'Tarjeta de identidad'], ['50', 'NIT de otro país']];
const RESP_FISCAL = [['R-99-PN', 'No aplica / consumidor final'], ['O-49', 'No responsable de IVA'], ['O-48', 'Responsable de IVA'], ['O-47', 'Régimen simple de tributación'], ['O-13', 'Gran contribuyente'], ['O-15', 'Autorretenedor'], ['O-23', 'Agente de retención IVA']];
const EMPTY = { razon_social:'', nit:'', dv:'', tipo_documento:'31', email:'', telefono:'', ciudad:'', direccion:'', departamento:'', codigo_departamento:'', codigo_municipio:'', codigo_postal:'', responsabilidad_fiscal:'R-99-PN', contacto_nombre:'', contacto_cargo:'' };

// Dígito de verificación del NIT (algoritmo DIAN).
export function calcularDV(nit) {
  const s = String(nit || '').replace(/\D/g, '');
  if (!s) return '';
  const pesos = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
  const d = s.split('').reverse();
  let sum = 0;
  for (let i = 0; i < d.length; i++) sum += parseInt(d[i], 10) * (pesos[i] || 0);
  const r = sum % 11;
  return String(r < 2 ? r : 11 - r);
}

export default function ClienteModal({ inicial = {}, onClose, onCreated }) {
  const [form, setForm] = useState({ ...EMPTY, ...inicial });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [correoRec, setCorreoRec] = useState(null); // correo de recepción DIAN por NIT

  // Al salir del NIT: busca el correo de recepción DIAN y lo precarga si el correo está vacío.
  const buscarCorreoRec = async () => {
    const nit = (form.nit || '').replace(/\D/g, '');
    if (nit.length < 6) { setCorreoRec(null); return; }
    try {
      const { data } = await getCorreoRecepcion(nit);
      if (data.encontrado && data.email) {
        setCorreoRec(data.email);
        setForm(f => (f.email ? f : { ...f, email: data.email }));
      } else { setCorreoRec(null); }
    } catch { setCorreoRec(null); }
  };

  const guardar = async () => {
    if (!form.razon_social || !form.nit) { setError('Razón social y NIT son requeridos'); return; }
    setSaving(true); setError('');
    try {
      const payload = { ...form, dv: form.dv || calcularDV(form.nit) };
      const { data } = await createCliente(payload);
      onCreated && onCreated(data);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al crear el cliente');
      setSaving(false);
    }
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <div style={s.header}>
          <h2 style={s.title}>Nuevo cliente</h2>
          <button style={s.close} onClick={onClose}>✕</button>
        </div>
        <div style={s.body}>
          {error && <div style={s.errorBox}>{error}</div>}
          <div style={s.grid2}>
            <div style={s.field}>
              <label style={s.label}>Razón social *</label>
              <input style={s.input} value={form.razon_social} onChange={e => set('razon_social', e.target.value)} />
            </div>
            <div style={s.field}>
              <label style={s.label}>Tipo de documento</label>
              <select style={s.input} value={form.tipo_documento} onChange={e => set('tipo_documento', e.target.value)}>
                {TIPOS_DOC.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <div style={{ ...s.field, flex: 1 }}>
                <label style={s.label}>{form.tipo_documento === '31' ? 'NIT *' : 'Número documento *'}</label>
                <input style={s.input} value={form.nit} onChange={e => { const nit = e.target.value; setForm(f => ({ ...f, nit, dv: calcularDV(nit) })); }} onBlur={buscarCorreoRec} />
              </div>
              <div style={{ ...s.field, width: 64 }}>
                <label style={s.label}>DV</label>
                <input style={{ ...s.input, textAlign: 'center', fontWeight: 700, color: '#93c5fd', background: '#0f172a' }} value={form.dv || calcularDV(form.nit)} readOnly title="Dígito de verificación (automático)" />
              </div>
            </div>
            <div style={s.field}>
              <label style={s.label}>Correo de facturación electrónica</label>
              <input style={s.input} type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="facturacion@empresa.com" />
              {correoRec && (
                <span style={{ fontSize:11, color: form.email === correoRec ? '#34d399' : '#93c5fd', marginTop:3, display:'flex', alignItems:'center', gap:6, flexWrap:'wrap' }}>
                  📩 Recepción DIAN: {correoRec}
                  {form.email !== correoRec && <button type="button" onClick={() => set('email', correoRec)} style={{ background:'none', border:'1px solid #334155', borderRadius:5, color:'#93c5fd', fontSize:10, padding:'1px 6px', cursor:'pointer' }}>usar</button>}
                </span>
              )}
              <div style={{ color:'#64748b', fontSize:11, marginTop:3 }}>Este correo va en el XML y el PDF de la factura y es el destinatario por defecto. Los demás (contacto, compras…) agrégalos como contactos.</div>
            </div>
            <div style={s.field}>
              <label style={s.label}>Teléfono</label>
              <input style={s.input} value={form.telefono} onChange={e => set('telefono', e.target.value)} />
            </div>
            <div style={s.field}>
              <label style={s.label}>Departamento</label>
              <select style={s.input} value={form.codigo_departamento}
                onChange={e => { const d = DEPARTAMENTOS.find(x => x.code === e.target.value); setForm(f => ({ ...f, codigo_departamento: e.target.value, departamento: d ? d.name : '', codigo_municipio: '', ciudad: '' })); }}>
                <option value="">— Seleccionar —</option>
                {DEPARTAMENTOS.map(d => <option key={d.code} value={d.code}>{d.name}</option>)}
              </select>
            </div>
            <div style={s.field}>
              <label style={s.label}>Municipio / Ciudad</label>
              <select style={s.input} value={form.codigo_municipio} disabled={!form.codigo_departamento}
                onChange={e => { const m = MUNICIPIOS.find(x => x.code === e.target.value); setForm(f => ({ ...f, codigo_municipio: e.target.value, ciudad: m ? m.name : '' })); }}>
                <option value="">{form.codigo_departamento ? '— Seleccionar —' : 'Elige departamento'}</option>
                {MUNICIPIOS.filter(m => m.code.slice(0, 2) === form.codigo_departamento).map(m => <option key={m.code} value={m.code}>{m.name}</option>)}
              </select>
            </div>
            <div style={s.field}>
              <label style={s.label}>Código postal</label>
              <input style={s.input} value={form.codigo_postal} placeholder="Ej: 110111" onChange={e => set('codigo_postal', e.target.value)} />
            </div>
            <div style={s.field}>
              <label style={s.label}>Responsabilidad fiscal</label>
              <select style={s.input} value={form.responsabilidad_fiscal} onChange={e => set('responsabilidad_fiscal', e.target.value)}>
                {RESP_FISCAL.map(([v, l]) => <option key={v} value={v}>{v} — {l}</option>)}
              </select>
            </div>
            {[['contacto_nombre', 'Nombre contacto'], ['contacto_cargo', 'Cargo contacto']].map(([k, label]) => (
              <div key={k} style={s.field}>
                <label style={s.label}>{label}</label>
                <input style={s.input} value={form[k]} onChange={e => set(k, e.target.value)} />
              </div>
            ))}
            <div style={{ ...s.field, gridColumn: '1 / -1' }}>
              <label style={s.label}>Dirección</label>
              <input style={s.input} value={form.direccion} onChange={e => set('direccion', e.target.value)} />
            </div>
          </div>
        </div>
        <div style={s.footer}>
          <button style={s.btnSecondary} onClick={onClose} disabled={saving}>Cancelar</button>
          <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={guardar} disabled={saving}>{saving ? 'Guardando…' : 'Crear cliente'}</button>
        </div>
      </div>
    </div>
  );
}

const s = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 },
  modal: { background: '#1e293b', border: '1px solid #334155', borderRadius: 14, width: '100%', maxWidth: 640, maxHeight: '92vh', display: 'flex', flexDirection: 'column' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #334155' },
  title: { color: '#f1f5f9', fontSize: 17, fontWeight: 700, margin: 0 },
  close: { background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer' },
  body: { padding: 20, overflowY: 'auto' },
  grid2: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14 },
  field: { display: 'flex', flexDirection: 'column', gap: 5 },
  label: { color: '#94a3b8', fontSize: 12 },
  input: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, height: 40, padding: '0 11px', color: '#f1f5f9', fontSize: 13, width: '100%', boxSizing: 'border-box' },
  errorBox: { background: '#450a0a', border: '1px solid #b91c1c', color: '#fca5a5', padding: '8px 12px', borderRadius: 8, marginBottom: 14, fontSize: 13 },
  footer: { display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '14px 20px', borderTop: '1px solid #334155' },
  btnSecondary: { background: '#334155', color: '#e2e8f0', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  btnPrimary: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
};
